module.exports = __webpack_public_path__ + "static/media/CUYA_Web_LandingPage_CalloutPhoot_RacingPulse.8f5ea856.jpg";